// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__m2Nml"};